'use strict';

// This is an auto-generated file. Please do not edit directly.
// For instructions on editing source .json files, please see:
// https://git.hubteam.com/HubSpot/UIComponents/tree/master/HubStyleTokens
// ***********************************************************************

'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var CALYPSO = exports.CALYPSO = '#00a4bd';
var CALYPSO_DARK = exports.CALYPSO_DARK = '#0091ae';
var CALYPSO_MEDIUM = exports.CALYPSO_MEDIUM = '#7fd1de';
var CALYPSO_LIGHT = exports.CALYPSO_LIGHT = '#e5f5f8';
var SORBET = exports.SORBET = '#ff8f59';
var SORBET_DARK = exports.SORBET_DARK = '#e68250';
var SORBET_MEDIUM = exports.SORBET_MEDIUM = '#ffc7ac';
var SORBET_LIGHT = exports.SORBET_LIGHT = '#fff3ee';
var LORAX = exports.LORAX = '#ff7a59';
var LORAX_DARK = exports.LORAX_DARK = '#e66e50';
var LORAX_MEDIUM = exports.LORAX_MEDIUM = '#ffbcac';
var LORAX_LIGHT = exports.LORAX_LIGHT = '#fff1ee';
var MARIGOLD = exports.MARIGOLD = '#f5c26b';
var MARIGOLD_DARK = exports.MARIGOLD_DARK = '#dbae60';
var MARIGOLD_MEDIUM = exports.MARIGOLD_MEDIUM = '#fae0b5';
var MARIGOLD_LIGHT = exports.MARIGOLD_LIGHT = '#fef8f0';
var CANDY_APPLE = exports.CANDY_APPLE = '#f2545b';
var CANDY_APPLE_DARK = exports.CANDY_APPLE_DARK = '#d94c53';
var CANDY_APPLE_MEDIUM = exports.CANDY_APPLE_MEDIUM = '#f8a9ad';
var CANDY_APPLE_LIGHT = exports.CANDY_APPLE_LIGHT = '#fdedee';
var NORMAN = exports.NORMAN = '#f2547d';
var NORMAN_DARK = exports.NORMAN_DARK = '#d94c71';
var NORMAN_MEDIUM = exports.NORMAN_MEDIUM = '#f9aabe';
var NORMAN_LIGHT = exports.NORMAN_LIGHT = '#fdedf2';
var THUNDERDOME = exports.THUNDERDOME = '#6a78d1';
var THUNDERDOME_DARK = exports.THUNDERDOME_DARK = '#5e6ab8';
var THUNDERDOME_MEDIUM = exports.THUNDERDOME_MEDIUM = '#b4bbe8';
var THUNDERDOME_LIGHT = exports.THUNDERDOME_LIGHT = '#f0f1fa';
var OZ = exports.OZ = '#00bda5';
var OZ_DARK = exports.OZ_DARK = '#00a38d';
var OZ_MEDIUM = exports.OZ_MEDIUM = '#7fded2';
var OZ_LIGHT = exports.OZ_LIGHT = '#e5f8f6';
var FLAT_EARTH = exports.FLAT_EARTH = '#253342';
var PANTERA = exports.PANTERA = '#2d3e50';
var OBSIDIAN = exports.OBSIDIAN = '#33475b';
var HEFFALUMP = exports.HEFFALUMP = '#425b76';
var SLINKY = exports.SLINKY = '#516f90';
var EERIE = exports.EERIE = '#7c98b6';
var FLINT = exports.FLINT = '#99acc2';
var BATTLESHIP = exports.BATTLESHIP = '#cbd6e2';
var GREAT_WHITE = exports.GREAT_WHITE = '#dfe3eb';
var KOALA = exports.KOALA = '#eaf0f6';
var CIRRUS = exports.CIRRUS = '#f2f5f8';
var GYPSUM = exports.GYPSUM = '#f5f8fa';
var OLAF = exports.OLAF = '#ffffff';
var MONOLITH = exports.MONOLITH = '#000000';
var CHART_RED = exports.CHART_RED = '#ea90b1';
var CHART_ORANGE = exports.CHART_ORANGE = '#fea58e';
var CHART_YELLOW = exports.CHART_YELLOW = '#f5c78e';
var CHART_GREEN = exports.CHART_GREEN = '#a2d28f';
var CHART_AQUA = exports.CHART_AQUA = '#51d3d9';
var CHART_BLUE = exports.CHART_BLUE = '#81c1fd';
var CHART_PURPLE = exports.CHART_PURPLE = '#bda9ea';
var CHART_DARK_PURPLE = exports.CHART_DARK_PURPLE = '#9784c2';
var LINK_HOVER = exports.LINK_HOVER = '#007a8c';
var BUTTON_PRIMARY_HOVER_FILL = exports.BUTTON_PRIMARY_HOVER_FILL = '#ff8f73';
var BUTTON_SECONDARY_TEXT = exports.BUTTON_SECONDARY_TEXT = '#ff7a53';
var BUTTON_SECONDARY_HOVER_FILL = exports.BUTTON_SECONDARY_HOVER_FILL = '#fff8f6';
var BUTTON_SECONDARY_ACTIVE_FILL = exports.BUTTON_SECONDARY_ACTIVE_FILL = '#ffebe6';
var BUTTON_TERTIARY_LIGHT_TEXT = exports.BUTTON_TERTIARY_LIGHT_TEXT = '#506e91';
var BUTTON_TERTIARY_LIGHT_HOVER_FILL = exports.BUTTON_TERTIARY_LIGHT_HOVER_FILL = '#e5eaf0';
var BUTTON_DANGER_HOVER_FILL = exports.BUTTON_DANGER_HOVER_FILL = '#ff5962';
var BUTTON_DISABLED_TEXT = exports.BUTTON_DISABLED_TEXT = '#b0c1d4';
var FOCUS_RING_BASE = exports.FOCUS_RING_BASE = '#00d0e4';
var ALERT_DANGER = exports.ALERT_DANGER = '#f04b51';
var ALERT_WARNING = exports.ALERT_WARNING = '#fdf3e1';
var ALERT_SUCCESS = exports.ALERT_SUCCESS = '#5967bc';
var LINKEDIN = exports.LINKEDIN = '#0077b5';
var TWITTER = exports.TWITTER = '#55acee';
var FACEBOOK = exports.FACEBOOK = '#3b5998';
var GOOGLE = exports.GOOGLE = '#dd4b39';
var XING = exports.XING = '#026466';
var PINTEREST = exports.PINTEREST = '#bd081c';
var RSS = exports.RSS = '#f26522';
var YOUTUBE = exports.YOUTUBE = '#cd201f';
var INSTAGRAM = exports.INSTAGRAM = '#c13584';
var TRANSPARENT_DARK = exports.TRANSPARENT_DARK = 'rgba(0, 0, 0, 0)';
var TRANSPARENT_LIGHT = exports.TRANSPARENT_LIGHT = 'rgba(255, 255, 255, 0)';
var TRANSPARENT = exports.TRANSPARENT = 'rgba(0, 0, 0, 0)';
var BASE_FONT_COLOR = exports.BASE_FONT_COLOR = '#33475b';
var BASE_LINK_COLOR = exports.BASE_LINK_COLOR = '#0091ae';
var BASE_LINK_ACTIVE_COLOR = exports.BASE_LINK_ACTIVE_COLOR = '#7fd1de';
var BASE_LINK_HOVER_COLOR = exports.BASE_LINK_HOVER_COLOR = '#007a8c';
var BASE_SELECTION_BACKGROUND_COLOR = exports.BASE_SELECTION_BACKGROUND_COLOR = '#eaf0f6';
var BASE_BACKGROUND_COLOR = exports.BASE_BACKGROUND_COLOR = '#ffffff';
var BASE_BACKGROUND_COLOR_MEDIUM = exports.BASE_BACKGROUND_COLOR_MEDIUM = '#f5f8fa';
var BASE_BACKGROUND_COLOR_DARK = exports.BASE_BACKGROUND_COLOR_DARK = '#33475b';
var BASE_FONT_CONTRAST_COLOR = exports.BASE_FONT_CONTRAST_COLOR = '#ffffff';
var BASE_SHADOW_COLOR = exports.BASE_SHADOW_COLOR = '#000000';
var BACK_BUTTON_ARROW_ON_DARK_COLOR = exports.BACK_BUTTON_ARROW_ON_DARK_COLOR = '#ffffff';
var BADGE_ROUNDED_BETA_BACKGROUND_COLOR = exports.BADGE_ROUNDED_BETA_BACKGROUND_COLOR = '#6a78d1';
var BADGE_ROUNDED_NEW_BACKGROUND_COLOR = exports.BADGE_ROUNDED_NEW_BACKGROUND_COLOR = '#00bda5';
var BADGE_ROUNDED_FOREGROUND_COLOR = exports.BADGE_ROUNDED_FOREGROUND_COLOR = '#ffffff';
var BADGE_TRIAL_AVAILABLE_BACKGROUND_COLOR = exports.BADGE_TRIAL_AVAILABLE_BACKGROUND_COLOR = '#ff7a59';
var BADGE_TRIAL_IN_PROGRESS_BACKGROUND_COLOR = exports.BADGE_TRIAL_IN_PROGRESS_BACKGROUND_COLOR = '#00bda5';
var BADGE_TRIAL_EXPIRED_BACKGROUND_COLOR = exports.BADGE_TRIAL_EXPIRED_BACKGROUND_COLOR = '#f2545b';
var BADGE_UPGRADE_FOREGROUND_COLOR = exports.BADGE_UPGRADE_FOREGROUND_COLOR = '#ffffff';
var BADGE_UPGRADE_SALES_PRO_BACKGROUND_COLOR = exports.BADGE_UPGRADE_SALES_PRO_BACKGROUND_COLOR = '#ff7a59';
var BADGE_UPGRADE_MARKETING_STARTER_BACKGROUND_COLOR = exports.BADGE_UPGRADE_MARKETING_STARTER_BACKGROUND_COLOR = '#6a78d1';
var BADGE_UPGRADE_MARKETING_BASIC_BACKGROUND_COLOR = exports.BADGE_UPGRADE_MARKETING_BASIC_BACKGROUND_COLOR = '#00a4bd';
var BADGE_UPGRADE_MARKETING_PRO_BACKGROUND_COLOR = exports.BADGE_UPGRADE_MARKETING_PRO_BACKGROUND_COLOR = '#00bda5';
var BADGE_UPGRADE_MARKETING_ENTERPRISE_BACKGROUND_COLOR = exports.BADGE_UPGRADE_MARKETING_ENTERPRISE_BACKGROUND_COLOR = '#425b76';
var BADGE_UPGRADE_ADD_ON_BACKGROUND_COLOR = exports.BADGE_UPGRADE_ADD_ON_BACKGROUND_COLOR = '#516f90';
var BUTTON_DISABLED_BACKGROUND_COLOR = exports.BUTTON_DISABLED_BACKGROUND_COLOR = '#eaf0f6';
var BUTTON_GROUP_ITEM_BACKGROUND_COLOR = exports.BUTTON_GROUP_ITEM_BACKGROUND_COLOR = '#f5f8fa';
var BUTTON_GROUP_ITEM_BORDER_COLOR = exports.BUTTON_GROUP_ITEM_BORDER_COLOR = '#cbd6e2';
var BUTTON_GROUP_ITEM_COLOR = exports.BUTTON_GROUP_ITEM_COLOR = '#516f90';
var BUTTON_GROUP_ITEM_HOVER_BACKGROUND_COLOR = exports.BUTTON_GROUP_ITEM_HOVER_BACKGROUND_COLOR = '#ffffff';
var BUTTON_GROUP_ITEM_SELECTED_BACKGROUND_COLOR = exports.BUTTON_GROUP_ITEM_SELECTED_BACKGROUND_COLOR = '#e5eaf0';
var CARD_SHADOW_COLOR = exports.CARD_SHADOW_COLOR = '#2d3e50';
var CHEVRON_BACKGROUND_COLOR = exports.CHEVRON_BACKGROUND_COLOR = '#eaf0f6';
var FLOATING_BUTTON_GROUP_ITEM_BACKGROUND_COLOR = exports.FLOATING_BUTTON_GROUP_ITEM_BACKGROUND_COLOR = '#425b76';
var FLOATING_BUTTON_GROUP_ITEM_BORDER_COLOR = exports.FLOATING_BUTTON_GROUP_ITEM_BORDER_COLOR = '#516f90';
var FLOATING_BUTTON_GROUP_ITEM_COLOR = exports.FLOATING_BUTTON_GROUP_ITEM_COLOR = '#ffffff';
var FLOATING_BUTTON_GROUP_ITEM_HOVER_BACKGROUND_COLOR = exports.FLOATING_BUTTON_GROUP_ITEM_HOVER_BACKGROUND_COLOR = '#516f90';
var FLOATING_BUTTON_GROUP_ITEM_SELECTED_BACKGROUND_COLOR = exports.FLOATING_BUTTON_GROUP_ITEM_SELECTED_BACKGROUND_COLOR = '#33475b';
var CHANGE_ARROW_INCREASE_COLOR = exports.CHANGE_ARROW_INCREASE_COLOR = '#00bda5';
var CHANGE_ARROW_DECREASE_COLOR = exports.CHANGE_ARROW_DECREASE_COLOR = '#f2545b';
var CODE_BACKGROUND_COLOR = exports.CODE_BACKGROUND_COLOR = '#eaf0f6';
var CODE_FOREGROUND_COLOR = exports.CODE_FOREGROUND_COLOR = '#33475b';
var CODE_BLOCK_BACKGROUND_COLOR = exports.CODE_BLOCK_BACKGROUND_COLOR = '#f5f8fa';
var CONTENT_EDITABLE_BACKGROUND_COLOR = exports.CONTENT_EDITABLE_BACKGROUND_COLOR = '#f5f8fa';
var CONTENT_EDITABLE_CONTRAST_BACKGROUND_COLOR = exports.CONTENT_EDITABLE_CONTRAST_BACKGROUND_COLOR = '#425b76';
var CONTENT_EDITABLE_CONTRAST_COLOR = exports.CONTENT_EDITABLE_CONTRAST_COLOR = '#ffffff';
var CONTENT_EDITABLE_PLACEHOLDER_COLOR = exports.CONTENT_EDITABLE_PLACEHOLDER_COLOR = '#7c98b6';
var CONTENT_EDITABLE_PLACEHOLDER_ON_DARK_COLOR = exports.CONTENT_EDITABLE_PLACEHOLDER_ON_DARK_COLOR = '#cbd6e2';
var CONTENT_EDITABLE_ICON_COLOR = exports.CONTENT_EDITABLE_ICON_COLOR = '#00a4bd';
var CONTENT_EDITABLE_ICON_ON_DARK_COLOR = exports.CONTENT_EDITABLE_ICON_ON_DARK_COLOR = '#ffffff';
var EXPANDING_TEXT_INPUT_BACKGROUND_COLOR = exports.EXPANDING_TEXT_INPUT_BACKGROUND_COLOR = '#f5f8fa';
var EXPANDING_TEXT_INPUT_CONTRAST_BACKGROUND_COLOR = exports.EXPANDING_TEXT_INPUT_CONTRAST_BACKGROUND_COLOR = '#425b76';
var EXPANDING_TEXT_INPUT_CONTRAST_COLOR = exports.EXPANDING_TEXT_INPUT_CONTRAST_COLOR = '#ffffff';
var EXPANDING_TEXT_INPUT_ICON_COLOR = exports.EXPANDING_TEXT_INPUT_ICON_COLOR = '#cbd6e2';
var CONNECTED_STEP_SELECTED_COLOR = exports.CONNECTED_STEP_SELECTED_COLOR = '#ff7a59';
var CONNECTED_STEP_UNSELECTED_COLOR = exports.CONNECTED_STEP_UNSELECTED_COLOR = '#cbd6e2';
var DARK_LINK_COLOR = exports.DARK_LINK_COLOR = '#ffffff';
var DARK_LINK_ACTIVE_COLOR = exports.DARK_LINK_ACTIVE_COLOR = '#eaf0f6';
var DARK_LINK_HOVER_COLOR = exports.DARK_LINK_HOVER_COLOR = '#7fd1de';
var DARK_LINK_ICON_COLOR = exports.DARK_LINK_ICON_COLOR = '#ffffff';
var BRIGHT_LINK_COLOR = exports.BRIGHT_LINK_COLOR = '#33475b';
var BRIGHT_LINK_ACTIVE_COLOR = exports.BRIGHT_LINK_ACTIVE_COLOR = '#33475b';
var BRIGHT_LINK_HOVER_COLOR = exports.BRIGHT_LINK_HOVER_COLOR = '#33475b';
var BRIGHT_LINK_ICON_COLOR = exports.BRIGHT_LINK_ICON_COLOR = '#425b76';
var DANGER_LINK_COLOR = exports.DANGER_LINK_COLOR = '#f2545b';
var DANGER_LINK_ACTIVE_COLOR = exports.DANGER_LINK_ACTIVE_COLOR = '#d94c53';
var DANGER_LINK_HOVER_COLOR = exports.DANGER_LINK_HOVER_COLOR = '#d94c53';
var MENTION_LINK_COLOR = exports.MENTION_LINK_COLOR = '#425b76';
var MENTION_LINK_ACTIVE_COLOR = exports.MENTION_LINK_ACTIVE_COLOR = '#33475b';
var MENTION_LINK_HOVER_COLOR = exports.MENTION_LINK_HOVER_COLOR = '#33475b';
var DROPDOWN_BACKGROUND_COLOR = exports.DROPDOWN_BACKGROUND_COLOR = '#ffffff';
var DROPDOWN_BORDER_COLOR = exports.DROPDOWN_BORDER_COLOR = '#cbd6e2';
var DROPDOWN_SELECTED_BACKGROUND_COLOR = exports.DROPDOWN_SELECTED_BACKGROUND_COLOR = '#e5f5f8';
var DROPDOWN_SEARCH_BACKGROUND_COLOR = exports.DROPDOWN_SEARCH_BACKGROUND_COLOR = '#ffffff';
var DROPDOWN_SEARCH_WRAPPER_BACKGROUND_COLOR = exports.DROPDOWN_SEARCH_WRAPPER_BACKGROUND_COLOR = '#eaf0f6';
var DROPDOWN_CARET_COLOR = exports.DROPDOWN_CARET_COLOR = '#00a4bd';
var TOOLBAR_DARK_BACKGROUND_COLOR = exports.TOOLBAR_DARK_BACKGROUND_COLOR = '#253342';
var TOOLBAR_DARK_FOREGROUND_COLOR = exports.TOOLBAR_DARK_FOREGROUND_COLOR = '#ffffff';
var EDITOR_LAYOUT_SHADOW_COLOR = exports.EDITOR_LAYOUT_SHADOW_COLOR = '#516f90';
var FORM_CONTROL_BACKGROUND_COLOR = exports.FORM_CONTROL_BACKGROUND_COLOR = '#f5f8fa';
var FORM_CONTROL_FOREGROUND_COLOR = exports.FORM_CONTROL_FOREGROUND_COLOR = '#33475b';
var FORM_CONTROL_BORDER_COLOR = exports.FORM_CONTROL_BORDER_COLOR = '#cbd6e2';
var FORM_CONTROL_READONLY_BACKGROUND_COLOR = exports.FORM_CONTROL_READONLY_BACKGROUND_COLOR = 'rgba(0, 0, 0, 0)';
var FORM_CONTROL_READONLY_BORDER_COLOR = exports.FORM_CONTROL_READONLY_BORDER_COLOR = 'rgba(0, 0, 0, 0)';
var FORM_COPYABLE_BACKGROUND_COLOR = exports.FORM_COPYABLE_BACKGROUND_COLOR = '#ffffff';
var FORM_DISABLED_COLOR = exports.FORM_DISABLED_COLOR = '#cbd6e2';
var FORM_DISABLED_BACKGROUND_COLOR = exports.FORM_DISABLED_BACKGROUND_COLOR = '#eaf0f6';
var FORM_PLACEHOLDER_COLOR = exports.FORM_PLACEHOLDER_COLOR = '#7c98b6';
var FORM_STATIC_LABELS_BACKGROUND_COLOR = exports.FORM_STATIC_LABELS_BACKGROUND_COLOR = '#eaf0f6';
var FORM_STATIC_LABELS_COLOR = exports.FORM_STATIC_LABELS_COLOR = '#7c98b6';
var FORM_TOGGLE_BACKGROUND_COLOR = exports.FORM_TOGGLE_BACKGROUND_COLOR = '#ffffff';
var FORM_TOGGLE_HOVER_BACKGROUND_COLOR = exports.FORM_TOGGLE_HOVER_BACKGROUND_COLOR = '#eaf0f6';
var FORM_TOGGLE_BORDER_COLOR = exports.FORM_TOGGLE_BORDER_COLOR = '#cbd6e2';
var FORM_TOGGLE_DISABLED_FOREGROUND_COLOR = exports.FORM_TOGGLE_DISABLED_FOREGROUND_COLOR = '#99acc2';
var FORM_TOGGLE_HOVER_FOREGROUND_COLOR = exports.FORM_TOGGLE_HOVER_FOREGROUND_COLOR = '#0091ae';
var FORM_TOGGLE_ICON_COLOR = exports.FORM_TOGGLE_ICON_COLOR = '#cbd6e2';
var FORM_TOGGLE_SELECTED_BACKGROUND_COLOR = exports.FORM_TOGGLE_SELECTED_BACKGROUND_COLOR = '#ffffff';
var FORM_TOGGLE_SELECTED_FOREGROUND_COLOR = exports.FORM_TOGGLE_SELECTED_FOREGROUND_COLOR = '#00a4bd';
var FORM_TOGGLE_SWITCH_BACKGROUND_COLOR = exports.FORM_TOGGLE_SWITCH_BACKGROUND_COLOR = '#f5f8fa';
var HR_BORDER_COLOR = exports.HR_BORDER_COLOR = '#dfe3eb';
var ICON_DEFAULT_COLOR = exports.ICON_DEFAULT_COLOR = '#7c98b6';
var MODAL_BACKGROUND_COLOR = exports.MODAL_BACKGROUND_COLOR = '#ffffff';
var MODAL_CLOSE_BUTTON_FOREGROUND_COLOR = exports.MODAL_CLOSE_BUTTON_FOREGROUND_COLOR = '#99acc2';
var MODAL_DANGER_FOREGROUND_COLOR = exports.MODAL_DANGER_FOREGROUND_COLOR = '#ffffff';
var MODAL_FOOTER_BACKGROUND_COLOR = exports.MODAL_FOOTER_BACKGROUND_COLOR = '#ffffff';
var MODAL_HEADER_BACKGROUND_COLOR = exports.MODAL_HEADER_BACKGROUND_COLOR = '#00bda5';
var MODAL_HEADER_FOREGROUND_COLOR = exports.MODAL_HEADER_FOREGROUND_COLOR = '#ffffff';
var MODAL_HEADER_START_GRADIENT = exports.MODAL_HEADER_START_GRADIENT = '#00a4bd';
var MODAL_HEADER_MIDDLE_GRADIENT = exports.MODAL_HEADER_MIDDLE_GRADIENT = '#00afb2';
var MODAL_HEADER_END_GRADIENT = exports.MODAL_HEADER_END_GRADIENT = '#00bda5';
var MODAL_HEADING_INVERTED_FOREGROUND_COLOR = exports.MODAL_HEADING_INVERTED_FOREGROUND_COLOR = '#ffffff';
var MODAL_UPGRADES_FOREGROUND_COLOR = exports.MODAL_UPGRADES_FOREGROUND_COLOR = '#ffffff';
var MODAL_UPGRADES_END_GRADIENT = exports.MODAL_UPGRADES_END_GRADIENT = '#ff8f59';
var MODAL_UPGRADES_START_GRADIENT = exports.MODAL_UPGRADES_START_GRADIENT = '#ff7a59';
var MODAL_SUCCESS_BACKGROUND_COLOR = exports.MODAL_SUCCESS_BACKGROUND_COLOR = '#00bda5';
var MODAL_SUCCESS_FOREGROUND_COLOR = exports.MODAL_SUCCESS_FOREGROUND_COLOR = '#ffffff';
var PAGINATION_ACTIVE_BACKGROUND_COLOR = exports.PAGINATION_ACTIVE_BACKGROUND_COLOR = '#cbd6e2';
var PAGINATION_HOVER_BACKGROUND_COLOR = exports.PAGINATION_HOVER_BACKGROUND_COLOR = '#eaf0f6';
var PAGINATION_SELECTED_BACKGROUND_COLOR = exports.PAGINATION_SELECTED_BACKGROUND_COLOR = '#e5f5f8';
var PAGINATION_SELECTED_BORDER_COLOR = exports.PAGINATION_SELECTED_BORDER_COLOR = '#7fd1de';
var SELECTABLE_BOX_BORDER_COLOR = exports.SELECTABLE_BOX_BORDER_COLOR = '#7fd1de';
var SELECTABLE_BOX_SHADOW_COLOR = exports.SELECTABLE_BOX_SHADOW_COLOR = 'rgba(0, 163, 189, .3)';
var SELECTABLE_BOX_SELECTED_BORDER_COLOR = exports.SELECTABLE_BOX_SELECTED_BORDER_COLOR = '#00a4bd';
var SELECTABLE_BOX_SELECTED_BACKGROUND_COLOR = exports.SELECTABLE_BOX_SELECTED_BACKGROUND_COLOR = '#e5f5f8';
var SIDENAV_FOREGROUND_COLOR = exports.SIDENAV_FOREGROUND_COLOR = '#33475b';
var SIDENAV_HOVERED_BACKGROUND_COLOR = exports.SIDENAV_HOVERED_BACKGROUND_COLOR = '#eaf0f6';
var SIDENAV_SELECTED_BACKGROUND_COLOR = exports.SIDENAV_SELECTED_BACKGROUND_COLOR = '#eaf0f6';
var TABLE_SORT_ARROW_COLOR = exports.TABLE_SORT_ARROW_COLOR = '#cbd6e2';
var TABLE_SORT_ARROW_SELECTED_COLOR = exports.TABLE_SORT_ARROW_SELECTED_COLOR = '#00a4bd';
var TABS_BORDER_COLOR = exports.TABS_BORDER_COLOR = '#cbd6e2';
var TABS_DISABLED_COLOR = exports.TABS_DISABLED_COLOR = '#99acc2';
var TABS_FOREGROUND_COLOR = exports.TABS_FOREGROUND_COLOR = '#33475b';
var TABS_FOREGROUND_FOCUS_COLOR = exports.TABS_FOREGROUND_FOCUS_COLOR = '#7c98b6';
var TABS_ENCLOSED_BACKGROUND_COLOR = exports.TABS_ENCLOSED_BACKGROUND_COLOR = '#f5f8fa';
var TABS_ENCLOSED_SELECTED_BACKGROUND_COLOR = exports.TABS_ENCLOSED_SELECTED_BACKGROUND_COLOR = '#ffffff';
var TABS_ENCLOSED_SELECTED_COLOR = exports.TABS_ENCLOSED_SELECTED_COLOR = '#f5f8fa';
var LOADING_INACTIVE_COLOR = exports.LOADING_INACTIVE_COLOR = '#cbd6e2';
var LOADING_DEFAULT_COLOR = exports.LOADING_DEFAULT_COLOR = '#7c98b6';
var LOADING_PRIMARY_COLOR = exports.LOADING_PRIMARY_COLOR = '#00a4bd';
var LOADING_ORANGE_COLOR = exports.LOADING_ORANGE_COLOR = '#e66e50';
var OVERLAY_BACKGROUND_COLOR = exports.OVERLAY_BACKGROUND_COLOR = '#2d3e50';
var OVERLAY_BACKGROUND_COLOR_TRANSLUCENT = exports.OVERLAY_BACKGROUND_COLOR_TRANSLUCENT = 'rgba(#2d3e50, .79)';
var PANEL_CLOSE_BUTTON_FOREGROUND_COLOR = exports.PANEL_CLOSE_BUTTON_FOREGROUND_COLOR = '#ffffff';
var PANEL_FOOTER_BACKGROUND_COLOR = exports.PANEL_FOOTER_BACKGROUND_COLOR = '#f5f8fa';
var PANEL_FOOTER_BORDER_COLOR = exports.PANEL_FOOTER_BORDER_COLOR = '#cbd6e2';
var PANEL_SHADOW_COLOR = exports.PANEL_SHADOW_COLOR = 'rgba(#425b76, .21)';
var TABLE_BACKGROUND_COLOR = exports.TABLE_BACKGROUND_COLOR = '#ffffff';
var TABLE_BORDER_COLOR = exports.TABLE_BORDER_COLOR = '#dfe3eb';
var TABLE_HEADER_BACKGROUND_COLOR = exports.TABLE_HEADER_BACKGROUND_COLOR = '#f5f8fa';
var TABLE_ROW_HOVER_BACKGROUND_COLOR = exports.TABLE_ROW_HOVER_BACKGROUND_COLOR = '#f5f8fa';
var TABLE_SORTABLE_HOVER_BACKGROUND_COLOR = exports.TABLE_SORTABLE_HOVER_BACKGROUND_COLOR = '#e5f5f8';
var TABLE_SORTABLE_HOVER_ICON_COLOR = exports.TABLE_SORTABLE_HOVER_ICON_COLOR = '#7c98b6';
var TABLE_SORTABLE_SORTED_BACKGROUND_COLOR = exports.TABLE_SORTABLE_SORTED_BACKGROUND_COLOR = '#eaf0f6';
var TAG_AVATAR_BORDER_COLOR = exports.TAG_AVATAR_BORDER_COLOR = '#7fd1de';
var TEMPLATE_SECTION_DIVIDER_BORDER_COLOR = exports.TEMPLATE_SECTION_DIVIDER_BORDER_COLOR = '#cbd6e2';
var TILE_BACKGROUND_COLOR = exports.TILE_BACKGROUND_COLOR = '#ffffff';
var TILE_BORDER_COLOR = exports.TILE_BORDER_COLOR = '#dfe3eb';
var TOOLTIP_FOREGROUND_COLOR = exports.TOOLTIP_FOREGROUND_COLOR = '#ffffff';
var TOOLTIP_DANGER_BACKGROUND_COLOR = exports.TOOLTIP_DANGER_BACKGROUND_COLOR = '#f2545b';
var TOOLTIP_DEFAULT_BACKGROUND_COLOR = exports.TOOLTIP_DEFAULT_BACKGROUND_COLOR = '#425b76';
var TOOLTIP_LONGFORM_BACKGROUND_COLOR = exports.TOOLTIP_LONGFORM_BACKGROUND_COLOR = '#ffffff';
var TOOLTIP_LONGFORM_CLOSE_BUTTON_COLOR = exports.TOOLTIP_LONGFORM_CLOSE_BUTTON_COLOR = '#0091ae';
var TOOLTIP_LONGFORM_FOCUS_COLOR = exports.TOOLTIP_LONGFORM_FOCUS_COLOR = '#00a4bd';
var WELL_HELP_TEXT_FOREGROUND_COLOR = exports.WELL_HELP_TEXT_FOREGROUND_COLOR = '#7c98b6';
var WIZARD_HEADER_BACKGROUND_COLOR = exports.WIZARD_HEADER_BACKGROUND_COLOR = '#ffffff';
var WIZARD_HEADER_BORDER_COLOR = exports.WIZARD_HEADER_BORDER_COLOR = '#cbd6e2';
var DEVICE_FRAME_COLOR = exports.DEVICE_FRAME_COLOR = '#7c98b6';


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/HubStyleTokens/static-2.487/js/theme.js
// module id = 193
// module chunks = 2 3